import { render } from "./Sidebar.vue?vue&type=template&id=5d95d8a4&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5d95d8a4&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=5d95d8a4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d95d8a4"]])

export default __exports__